import React from "react";
import {
  SiShopify, SiReact, SiNodedotjs, SiNextdotjs, SiLaravel, SiPhp,
  SiJavascript, SiTypescript, SiMongodb, SiMysql, SiElasticsearch,
  SiRedis, SiDocker, SiGit, SiLinux, SiVercel, SiPostman,
  SiTailwindcss, SiPython, SiGo, SiRuby, SiRubyonrails, SiDjango,
  SiPostgresql, SiSqlite, SiAmazon, SiCloudflare, SiKubernetes,
  SiGraphql, SiFirebase, SiSupabase, SiPrisma, SiVuedotjs, SiSvelte,
  SiAstro, SiHtml5, SiCss3, SiSass, SiNginx, SiApache, SiJenkins,
  SiGithub, SiGitlab, SiBitbucket, SiJira, SiSlack, SiNotion,
  SiFigma, SiAdobeillustrator, SiAdobephotoshop, SiSpring,
} from "react-icons/si";
import { mediaUrl } from "../lib/api";

const ICONS = {
  shopify: SiShopify, react: SiReact, nodedotjs: SiNodedotjs, "node.js": SiNodedotjs,
  nextdotjs: SiNextdotjs, "next.js": SiNextdotjs, laravel: SiLaravel, php: SiPhp,
  javascript: SiJavascript, js: SiJavascript, typescript: SiTypescript, ts: SiTypescript,
  mongodb: SiMongodb, mysql: SiMysql, elasticsearch: SiElasticsearch, redis: SiRedis,
  docker: SiDocker, git: SiGit, linux: SiLinux, vercel: SiVercel, postman: SiPostman,
  tailwind: SiTailwindcss, tailwindcss: SiTailwindcss,
  python: SiPython, go: SiGo, golang: SiGo, ruby: SiRuby, "ruby-on-rails": SiRubyonrails,
  rubyonrails: SiRubyonrails, django: SiDjango, postgres: SiPostgresql, postgresql: SiPostgresql,
  sqlite: SiSqlite, aws: SiAmazon, amazon: SiAmazon, cloudflare: SiCloudflare,
  kubernetes: SiKubernetes, k8s: SiKubernetes, graphql: SiGraphql, firebase: SiFirebase,
  supabase: SiSupabase, prisma: SiPrisma, vue: SiVuedotjs, vuedotjs: SiVuedotjs,
  svelte: SiSvelte, astro: SiAstro, html: SiHtml5, html5: SiHtml5, css: SiCss3, css3: SiCss3,
  sass: SiSass, nginx: SiNginx, apache: SiApache, jenkins: SiJenkins, github: SiGithub,
  gitlab: SiGitlab, bitbucket: SiBitbucket, jira: SiJira, slack: SiSlack, notion: SiNotion,
  figma: SiFigma, illustrator: SiAdobeillustrator, photoshop: SiAdobephotoshop, spring: SiSpring,
};

export default function StackIcon({ iconKey, iconUrl, label, ...rest }) {
  if (iconUrl) {
    return <img src={mediaUrl(iconUrl)} alt={label || iconKey || "icon"} {...rest} style={{ width: "1em", height: "1em", objectFit: "contain", ...(rest.style || {}) }} />;
  }
  const key = String(iconKey || "").toLowerCase().replace(/\s+/g, "");
  const Cmp = ICONS[key];
  if (Cmp) return <Cmp {...rest} />;
  // Fallback: first letter badge
  const letter = (label || iconKey || "?").trim().charAt(0).toUpperCase();
  return (
    <span
      {...rest}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "1em",
        height: "1em",
        borderRadius: 8,
        background: "rgba(255,255,255,0.06)",
        color: "var(--text-soft)",
        fontFamily: "var(--font-display)",
        fontSize: "0.5em",
        fontWeight: 600,
        ...(rest.style || {}),
      }}
    >
      {letter}
    </span>
  );
}

export const ICON_KEYS = Object.keys(ICONS).sort();
